/**
 * Identificativo di questa scheda del browser nei blocchi di modifica. È casuale a ogni apertura, così
 * due schede (anche dello stesso utente) non si scambiano per la stessa. L'unica eccezione è il ricaricamento
 * voluto dopo aver ripreso un blocco: la pagina lascia l'id in sessionStorage e quella nuova lo riprende,
 * altrimenti si bloccherebbe da sola.
 *
 * È un modulo senza dipendenze: lo usa anche l'interceptor, che non può iniettare servizi che usano HttpClient.
 */
const HANDOVER_KEY = 'nes-ticket-lock-holder-handover';

const newId = () => {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
      .toString(36)
      .slice(2)}`;
  }
};

const initialId = () => {
  try {
    const handed = sessionStorage.getItem(HANDOVER_KEY);
    if (handed) {
      sessionStorage.removeItem(HANDOVER_KEY);
      return handed;
    }
  } catch {
    // sessionStorage non disponibile: si parte con un id nuovo
  }
  return newId();
};

export const TAB_LOCK_HOLDER_ID = initialId();

/** Da chiamare subito prima di ricaricare la pagina per tenere lo stesso id. */
export const keepLockHolderForReload = () => {
  try {
    sessionStorage.setItem(HANDOVER_KEY, TAB_LOCK_HOLDER_ID);
  } catch {
    // senza sessionStorage il ricaricamento riparte da un id nuovo
  }
};
